// extracted by mini-css-extract-plugin
export var active = "_ap-7";
export var container = "_ap-0";
export var evenWidth = "_ap-4";
export var large = "_ap-5";
export var outlet = "_ap-8";
export var slide = "_ap-2";
export var small = "_ap-6";
export var tab = "_ap-3";
export var tabs = "_ap-1";